import { inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';

export type ApplicationType = 'purchase' | 'refinance' | 'cash';

@Injectable({
  providedIn: 'root',
})
export class ApplicationTypeService {
  private readonly router = inject(Router);

  readonly showApplicationTypeSelector = signal(false);

  openApplicationTypeSelector(): void {
    this.showApplicationTypeSelector.set(true);
  }

  closeApplicationTypeSelector(): void {
    this.showApplicationTypeSelector.set(false);
  }

  onApplicationTypeSelected(type: ApplicationType): void {
    this.closeApplicationTypeSelector();

    if (type === 'refinance') {
      this.router.navigate(['/apply/refinance']);
    } else if (type === 'purchase') {
      this.router.navigate(['/apply/purchase']);
    }
  }
}
